import Todo from "../contracts/Todo.json";

const abi = Todo.abi;

export default abi;
